<h2 mat-dialog-title>Revisar solicitud de formación</h2>

<mat-dialog-content>
  <div class="request-info">
    <p><strong>Propuesto por:</strong> {{ proposer_full_name }}</p>
    <p><strong>Título:</strong> {{ data.title }}</p>
    <p><strong>Precio:</strong> {{ data.price }}</p>
    <p>
      <strong>Estado:</strong>
      {{ learning_resource_request_status_enum_labels[data.status] }}
    </p>
    @if (data.url) {
      <p>
        <a mat-button color="primary" [href]="data.url" target="_blank" rel="noopener noreferrer">
          <mat-icon>open_in_new</mat-icon>
          Ver curso
        </a>
      </p>
    }
    <p><strong>Observaciones:</strong></p>
    <p class="observations-text">{{ data.observations }}</p>
    <p><strong>Fecha solicitud:</strong> {{ data.created_at | date: 'dd/MM/yyyy HH:mm' }}</p>
  </div>

  @if (is_pending) {
    <p class="section-title">Datos del recurso formativo en catálogo</p>
    <form [formGroup]="accept_form" class="accept-form">
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Nombre en catálogo</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Caducidad (meses)</mat-label>
        <input matInput type="number" formControlName="expiration_in_months" min="1" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Duración (horas)</mat-label>
        <input matInput type="number" formControlName="duration_in_hours" min="1" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Skills</mat-label>
        <mat-select formControlName="skill_ids" multiple>
          @for (skill of skills(); track skill.id) {
            <mat-option [value]="skill.id">{{ skill.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
</mat-dialog-content>

@if (is_pending) {
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()" [disabled]="loading()">Cerrar</button>
    <button mat-flat-button color="warn" type="button" (click)="decline()" [disabled]="loading()">Rechazar</button>
    <button mat-flat-button color="accent" type="button" (click)="accept()" [disabled]="loading() || accept_form.invalid">Aceptar</button>
  </mat-dialog-actions>
} @else {
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Cerrar</button>
  </mat-dialog-actions>
}
